<template>
  <Guide :titleList="titleList">
    <template #innerContent>
    <div style="width: 100%; height: 50px; margin-top: 30px;"></div>
      <div class="wa_doc_body">
        <h1>{{ t('whatsapp.doc.h1') }}</h1>
        <div class="wa_doc_desc">{{ t('whatsapp.doc.desc') }}</div>
        <br>
        <br>

        <div id="part1" style="margin-top: 30px;">
          <CollapseItem :title="t('whatsapp.doc.section1.title')" :level="1" v-model:visible="isShow1">
            <br>
            <br>
            <div class="wa_doc_p">
              {{ t('whatsapp.doc.section1.p1.before') }}
              <span class="w700">{{ t('whatsapp.doc.section1.p1.bold') }}</span>
              {{ t('whatsapp.doc.section1.p1.after') }}
            </div>
            <br>
            <ul class="wa_doc_ul">
              <li>{{ t('whatsapp.doc.section1.list1.item1') }}</li>
              <li>{{ t('whatsapp.doc.section1.list1.item2') }}</li>
              <li>{{ t('whatsapp.doc.section1.list1.item3') }}</li>
            </ul>
            <br>
            <div class="wa_doc_p">
              <span class="w700">{{ t('whatsapp.doc.section1.note.label') }}</span>
              {{ t('whatsapp.doc.section1.note.text') }}
            </div>
          </CollapseItem>
        </div>

        <div id="part2" style="margin-top: 30px;">
          <CollapseItem :title="t('whatsapp.doc.section2.title')" :level="1" v-model:visible="isShow2">
            <div id="part_child_2_1">
              <CollapseItem :title="t('whatsapp.doc.section2.sub1.title')" :level="2" v-model:visible="isShow2_1">
                <br>
                <ul class="wa_doc_ul">
                  <li>{{ t('whatsapp.doc.section2.sub1.item1') }}</li>
                  <li>{{ t('whatsapp.doc.section2.sub1.item2') }}</li>
                </ul>
              </CollapseItem>
            </div>

            <div id="part_child_2_2">
              <CollapseItem :title="t('whatsapp.doc.section2.sub2.title')" :level="2" v-model:visible="isShow2_2">
                <br>
                <ul class="wa_doc_ul">
                  <li>{{ t('whatsapp.doc.section2.sub2.item1') }}</li>
                  <li>{{ t('whatsapp.doc.section2.sub2.item2') }}</li>
                </ul>
              </CollapseItem>
            </div>

            <div id="part_child_2_3">
              <CollapseItem :title="t('whatsapp.doc.section2.sub3.title')" :level="2" v-model:visible="isShow2_3">
                <br>
                <ul class="wa_doc_ul">
                  <li>{{ t('whatsapp.doc.section2.sub3.item1') }}</li>
                  <li>{{ t('whatsapp.doc.section2.sub3.item2') }}</li>
                </ul>
              </CollapseItem>
            </div>

            <div id="part_child_2_4">
              <CollapseItem :title="t('whatsapp.doc.section2.sub4.title')" :level="2" v-model:visible="isShow2_4">
                <br>
                <ul class="wa_doc_ul">
                  <li>{{ t('whatsapp.doc.section2.sub4.item1') }}</li>
                  <li>{{ t('whatsapp.doc.section2.sub4.item2') }}</li>
                  <li>
                    <span class="w700">{{ t('whatsapp.doc.section2.sub4.item3.bold') }}</span>
                    {{ t('whatsapp.doc.section2.sub4.item3.after') }}
                  </li>
                </ul>
              </CollapseItem>
            </div>

            <div id="part_child_2_5">
              <CollapseItem :title="t('whatsapp.doc.section2.sub5.title')" :level="2" v-model:visible="isShow2_5">
                <br>
                <ul class="wa_doc_ul">
                  <li>
                    {{ t('whatsapp.doc.section2.sub5.item1.before') }}
                    <span class="w700">{{ t('whatsapp.doc.section2.sub5.item1.bold') }}</span>
                    {{ t('whatsapp.doc.section2.sub5.item1.after') }}
                  </li>
                  <li>{{ t('whatsapp.doc.section2.sub5.item2') }}</li>
                  <li>{{ t('whatsapp.doc.section2.sub5.item3') }}</li>
                </ul>
              </CollapseItem>
            </div>
          </CollapseItem>
        </div>

        <div id="part3" style="margin-top: 30px;">
          <CollapseItem :title="t('whatsapp.doc.section3.title')" :level="1" v-model:visible="isShow3">
            <br>
            <ul class="wa_doc_ul">
              <li>
                <span class="w700">{{ t('whatsapp.doc.section3.item1.bold') }}</span>
                {{ t('whatsapp.doc.section3.item1.after') }}
              </li>
              <li>
                <span class="w700">{{ t('whatsapp.doc.section3.item2.bold') }}</span>
                {{ t('whatsapp.doc.section3.item2.after') }}
              </li>
              <li>
                <span class="w700">{{ t('whatsapp.doc.section3.item3.bold') }}</span>
                {{ t('whatsapp.doc.section3.item3.after') }}
              </li>
            </ul>
          </CollapseItem>
        </div>

        <div id="part4" style="margin-top: 30px;">
          <CollapseItem :title="t('whatsapp.doc.section4.title')" :level="1" v-model:visible="isShow4">
            <div id="part_child_4_1">
              <CollapseItem :title="t('whatsapp.doc.section4.sub1.title')" :level="2" v-model:visible="isShow4_1">
                <br>
                <ul class="wa_doc_ul">
                  <li>{{ t('whatsapp.doc.section4.sub1.item1') }}</li>
                  <li>{{ t('whatsapp.doc.section4.sub1.item2') }}</li>
                  <li>{{ t('whatsapp.doc.section4.sub1.item3') }}</li>
                </ul>
              </CollapseItem>
            </div>

            <div id="part_child_4_2">
              <CollapseItem :title="t('whatsapp.doc.section4.sub2.title')" :level="2" v-model:visible="isShow4_2">
                <br>
                <ul class="wa_doc_ul">
                  <li>{{ t('whatsapp.doc.section4.sub2.item1') }}</li>
                  <li>{{ t('whatsapp.doc.section4.sub2.item2') }}</li>
                  <li>{{ t('whatsapp.doc.section4.sub2.item3') }}</li>
                </ul>
              </CollapseItem>
            </div>

            <div id="part_child_4_3">
              <CollapseItem :title="t('whatsapp.doc.section4.sub3.title')" :level="2" v-model:visible="isShow4_3">
                <br>
                <div class="wa_doc_p">
                  {{ t('whatsapp.doc.section4.sub3.p1.before') }}
                  <span class="w700">{{ t('whatsapp.doc.section4.sub3.p1.bold') }}</span>
                  {{ t('whatsapp.doc.section4.sub3.p1.after') }}
                </div>
                <br>
                <div class="w700 wa_doc_h4">{{ t('whatsapp.doc.section4.sub3.week1.title') }}</div>
                <br>
                <ul class="wa_doc_ul">
                  <li>{{ t('whatsapp.doc.section4.sub3.week1.item1') }}</li>
                  <li>{{ t('whatsapp.doc.section4.sub3.week1.item2') }}</li>
                  <li>{{ t('whatsapp.doc.section4.sub3.week1.item3') }}</li>
                </ul>
                <br>
                <div class="w700 wa_doc_h4">{{ t('whatsapp.doc.section4.sub3.week2.title') }}</div>
                <br>
                <ul class="wa_doc_ul">
                  <li>{{ t('whatsapp.doc.section4.sub3.week2.item1') }}</li>
                  <li>{{ t('whatsapp.doc.section4.sub3.week2.item2') }}</li>
                </ul>
                <br>
                <div class="w700 wa_doc_h4">{{ t('whatsapp.doc.section4.sub3.week3.title') }}</div>
                <br>
                <ul class="wa_doc_ul">
                  <li>{{ t('whatsapp.doc.section4.sub3.week3.item1') }}</li>
                  <li>{{ t('whatsapp.doc.section4.sub3.week3.item2') }}</li>
                </ul>
              </CollapseItem>
            </div>

            <div id="part_child_4_4">
              <CollapseItem :title="t('whatsapp.doc.section4.sub4.title')" :level="2" v-model:visible="isShow4_4">
                <br>
                <ul class="wa_doc_ul">
                  <li>{{ t('whatsapp.doc.section4.sub4.item1') }}</li>
                  <li>{{ t('whatsapp.doc.section4.sub4.item2') }}</li>
                  <li>{{ t('whatsapp.doc.section4.sub4.item3') }}</li>
                  <li>{{ t('whatsapp.doc.section4.sub4.item4') }}</li>
                </ul>
                <br>
                <div class="wa_doc_p">
                  <span class="w700">{{ t('whatsapp.doc.section4.sub4.note.label') }}</span>
                  {{ t('whatsapp.doc.section4.sub4.note.text') }}
                </div>
              </CollapseItem>
            </div>

            <div id="part_child_4_5">
              <CollapseItem :title="t('whatsapp.doc.section4.sub5.title')" :level="2" v-model:visible="isShow4_5">
                <br>
                <ul class="wa_doc_ul">
                  <li>{{ t('whatsapp.doc.section4.sub5.item1') }}</li>
                  <li>{{ t('whatsapp.doc.section4.sub5.item2') }}</li>
                  <li>{{ t('whatsapp.doc.section4.sub5.item3') }}</li>
                  <li>{{ t('whatsapp.doc.section4.sub5.item4') }}</li>
                  <li>{{ t('whatsapp.doc.section4.sub5.item5') }}</li>
                </ul>
              </CollapseItem>
            </div>

            <div id="part_child_4_6">
              <CollapseItem :title="t('whatsapp.doc.section4.sub6.title')" :level="2" v-model:visible="isShow4_6">
                <br>
                <div class="wa_doc_p">{{ t('whatsapp.doc.section4.sub6.p1') }}</div>
                <br>
                <ul class="wa_doc_ul">
                  <li>{{ t('whatsapp.doc.section4.sub6.item1') }}</li>
                  <li>{{ t('whatsapp.doc.section4.sub6.item2') }}</li>
                  <li>{{ t('whatsapp.doc.section4.sub6.item3') }}</li>
                </ul>
                <br>
                <div class="wa_doc_p">
                  <span class="w700">{{ t('whatsapp.doc.section4.sub6.note.label') }}</span>
                  {{ t('whatsapp.doc.section4.sub6.note.text') }}
                </div>
              </CollapseItem>
            </div>
          </CollapseItem>
        </div>

        <div id="part6" style="margin-top: 30px;">
          <CollapseItem :title="t('whatsapp.doc.section6.title')" :level="1" v-model:visible="isShow6">
            <br>
            <div class="wa_doc_p">{{ t('whatsapp.doc.section6.p1') }}</div>
            <br>
            <br>
            <div id="part_child_6_1">
              <CollapseItem :title="t('whatsapp.doc.section6.sub1.title')" :level="2" v-model:visible="isShow6_1">
                <br>
                <div class="wa_doc_p">{{ t('whatsapp.doc.section6.sub1.p1') }}</div>
              </CollapseItem>
            </div>

            <div id="part_child_6_2">
              <CollapseItem :title="t('whatsapp.doc.section6.sub2.title')" :level="2" v-model:visible="isShow6_2">
                <br>
                <ul class="wa_doc_ul">
                  <li>{{ t('whatsapp.doc.section6.sub2.item1') }}</li>
                  <li>{{ t('whatsapp.doc.section6.sub2.item2') }}</li>
                  <li>{{ t('whatsapp.doc.section6.sub2.item3') }}</li>
                </ul>
              </CollapseItem>
            </div>

            <div id="part_child_6_3">
              <CollapseItem :title="t('whatsapp.doc.section6.sub3.title')" :level="2" v-model:visible="isShow6_3">
                <br>
                <div class="wa_doc_p">{{ t('whatsapp.doc.section6.sub3.p1') }}</div>
                <br>
                <ul class="wa_doc_ul">
                  <li>{{ t('whatsapp.doc.section6.sub3.item1') }}</li>
                  <li>{{ t('whatsapp.doc.section6.sub3.item2') }}</li>
                  <li>{{ t('whatsapp.doc.section6.sub3.item3') }}</li>
                </ul>
                <br>
                <div class="wa_doc_p">
                  <span class="w700">{{ t('whatsapp.doc.section6.sub3.note.label') }}</span>
                  {{ t('whatsapp.doc.section6.sub3.note.text') }}
                </div>
              </CollapseItem>
            </div>
          </CollapseItem>
        </div>

        <div id="part7" style="margin-top: 30px;">
          <CollapseItem :title="t('whatsapp.doc.section7.title')" :level="1" v-model:visible="isShow7">
            <br>
            <div class="wa_doc_p">{{ t('whatsapp.doc.section7.p1') }}</div>
            <br>
            <ul class="wa_doc_ul">
              <li>{{ t('whatsapp.doc.section7.item1') }}</li>
              <li>{{ t('whatsapp.doc.section7.item2') }}</li>
              <li>{{ t('whatsapp.doc.section7.item3') }}</li>
            </ul>
          </CollapseItem>
        </div>

        <div id="part8" style="margin-top: 30px;">
          <CollapseItem :title="t('whatsapp.doc.section8.title')" :level="1" v-model:visible="isShow8">
            <br>
            <div class="wa_doc_p">{{ t('whatsapp.doc.section8.p1') }}</div>
            <br>
            <div class="wa_doc_p">{{ t('whatsapp.doc.section8.p2') }}</div>
          </CollapseItem>
        </div>
      </div>
    </template>
  </Guide>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import Guide from '@/views/FileDoc/components/Guide.vue'
import CollapseItem from '@/views/FileDoc/components/CollapseItem.vue'

const router = useRouter()
const { t } = useI18n()

const flags = true
const isShow1 = ref(flags)
const isShow2 = ref(flags)
const isShow2_1 = ref(flags)
const isShow2_2 = ref(flags)
const isShow2_3 = ref(flags)
const isShow2_4 = ref(flags)
const isShow2_5 = ref(flags)
const isShow3 = ref(flags)
const isShow4 = ref(flags)
const isShow4_1 = ref(flags)
const isShow4_2 = ref(flags)
const isShow4_3 = ref(flags)
const isShow4_4 = ref(flags)
const isShow4_5 = ref(flags)
const isShow4_6 = ref(flags)
const isShow6 = ref(flags)
const isShow6_1 = ref(flags)
const isShow6_2 = ref(flags)
const isShow6_3 = ref(flags)
const isShow7 = ref(flags)
const isShow8 = ref(flags)

const titleList = [
  {
    id: 1,
    title: t('whatsapp.doc.section1.title'),
    href: '#part1',
    isExpanded: true,
    childList: []
  },
  {
    id: 2,
    title: t('whatsapp.doc.section2.title'),
    href: '#part2',
    isExpanded: false,
    childList: [
      { title: t('whatsapp.doc.section2.sub1.title'), href: '#part_child_2_1' },
      { title: t('whatsapp.doc.section2.sub2.title'), href: '#part_child_2_2' },
      { title: t('whatsapp.doc.section2.sub3.title'), href: '#part_child_2_3' },
      { title: t('whatsapp.doc.section2.sub4.title'), href: '#part_child_2_4' },
      { title: t('whatsapp.doc.section2.sub5.title'), href: '#part_child_2_5' }
    ]
  },
  {
    id: 3,
    title: t('whatsapp.doc.section3.title'),
    href: '#part3',
    isExpanded: false,
    childList: []
  },
  {
    id: 4,
    title: t('whatsapp.doc.section4.title'),
    href: '#part4',
    isExpanded: false,
    childList: [
      { title: t('whatsapp.doc.section4.sub1.title'), href: '#part_child_4_1' },
      { title: t('whatsapp.doc.section4.sub2.title'), href: '#part_child_4_2' },
      { title: t('whatsapp.doc.section4.sub3.title'), href: '#part_child_4_3' },
      { title: t('whatsapp.doc.section4.sub4.title'), href: '#part_child_4_4' },
      { title: t('whatsapp.doc.section4.sub5.title'), href: '#part_child_4_5' },
      { title: t('whatsapp.doc.section4.sub6.title'), href: '#part_child_4_6' }
    ]
  },
  {
    id: 6,
    title: t('whatsapp.doc.section6.title'),
    href: '#part6',
    isExpanded: false,
    childList: [
      { title: t('whatsapp.doc.section6.sub1.title'), href: '#part_child_6_1' },
      { title: t('whatsapp.doc.section6.sub2.title'), href: '#part_child_6_2' },
      { title: t('whatsapp.doc.section6.sub3.title'), href: '#part_child_6_3' }
    ]
  },
  {
    id: 7,
    title: t('whatsapp.doc.section7.title'),
    href: '#part7',
    isExpanded: false,
    childList: []
  },
  {
    id: 8,
    title: t('whatsapp.doc.section8.title'),
    href: '#part8',
    isExpanded: false,
    childList: []
  }
]

const handleBack = () => {
  try {
    router.back()
  } catch (e) {
    router.replace('/')
  }
}
</script>

<style lang="less" scoped>
// @import "~@/views/FileDoc/index.less";
.wa_doc_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 24px 0 12px;
}

.wa_doc_title {
  font-size: 18px;
  font-weight: 600;
}

.wa_doc_body {
  padding-bottom: 60px;

  h1 {
    margin: 0;
  }
}

.wa_doc_desc {
  margin-top: 20px;
  line-height: 24px;
}

.wa_doc_p {
  line-height: 22px;
}

.wa_doc_h2 {
  margin-top: 6px;
}

.wa_doc_h3 {
  font-size: 16px;
}

.wa_doc_h4 {
  font-size: 14px;
}

.wa_doc_ul {
  margin: 0;
  padding-left: 20px;

  li {
    margin: 8px 0;
    line-height: 22px;
  }

  li::marker {
    font-size: 24px !important;
    color: #000;
  }
}

.wa_doc_block {
  margin-top: 24px;
  padding: 16px 18px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #fff;
}

.wa_doc_block_title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
}

.wa_doc_list {
  margin: 0;
  padding-left: 18px;

  li {
    margin: 6px 0;
    line-height: 22px;
  }

  li::marker {
    font-size: 24px !important;
    color: #000;
  }
}


:deep(.el-icon) {
  font-size: 16px !important;
}

.step {
  width: max-content;
  background: rgb(252, 231, 90);
}

.w700 {
  font-weight: 700;
}

.red {
  color: rgb(223, 42, 63);
}
</style>


